export default __webpack_public_path__ + "locales/it/ConvertDialog.json?hash=9cda0898961f7149229aa3a60aa5b58e";